module.exports = __webpack_public_path__ + "img/comoros.d0d2f39d.svg";